import styled from 'styled-components'

export const FieldSetWrapper = styled.fieldset`
  border: none;

  legend {
    font-family: ${({ theme }) => theme.fonts.bloggerSans};
    font-size: 20px;
    margin-bottom: ${({ theme }) => theme.spacings[4]};

    color: ${({ theme }) => theme.colors.greyishBrown};
  }

  & + fieldset {
    margin-top: ${({ theme }) => theme.spacings[4]};
  }
`
